module.exports = __webpack_public_path__ + "exo-latin-900italic.90bea911b093ad5f0cf2.svg";


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/typeface-exo/files/exo-latin-900italic.svg
// module id = ../../../../typeface-exo/files/exo-latin-900italic.svg
// module chunks = styles